//Global Imports
import React from "react";
import clsx from "clsx";
import { Controller, useForm } from "react-hook-form";
//End Global Imports

//Local Imports
import Button from "../../../../components/ui/Button";
import Dropdown from "../../../../components/ui/Dropdown";
import Checkbox from "../../../../components/ui/Checkbox";
import TextField from "../../../../components/ui/TextField";
import Tooltip from "../../../../components/ui/Tooltip";
import { DoubleVerifiedIcon } from "../../../../assets/Icons";
import {
  getErrorMessage,
  regexForEmailAddress,
  regexForMobileNumber,
  regexForPassword,
  regexForSpecialChar,
} from "../../../../utils";
import { IStepOne } from "./StepOne";
import { sendOtp } from "../../../../services/auth";
import ErrorField from "../../../../components/ui/ErrorField";
import { Mixpanel } from "../../../../constants/mixpanel";
//End Local Imports

const StepOne: React.FC<IStepOne.IProps> = ({
  countryCode,
  setActiveStep,
  saveUserData,
  saveCountryCode,
  setIsTermsModalOpen,
  userData,
}) => {
  const countryCodeDefaultValue = (
    <span className="flex items-center justify-start space-x-2 text-base font-medium text-black font-ssp">
      <img src={`/images/png/INR.png`} alt="" width="35px" height="35px" />
      <div>+91</div>
    </span>
  );

  const [isAgree, setIsAgree] = React.useState<boolean>(false);
  const [value, setValue] = React.useState(countryCodeDefaultValue);
  const [showDropdown, setShowDropdown] = React.useState<boolean>(false);
  const [signUpError, setSignUpError] = React.useState<string>("");

  const coutryList = [
    {
      name: "United States +1",
      icon: "USD.png",
    },
    {
      name: "Canada +1",
      icon: "CAD.png",
    },
    {
      name: "India +91",
      icon: "INR.png",
    },
    {
      name: "United Kingdom +44",
      icon: "GBP.png",
    },
  ];

  const RadioLabel = (
    <div>
      <span className="pr-2 text-sm font-medium text-black font-lato">I agree to HOP’s</span>
      <span
        className="text-sm font-normal cursor-pointer font-lato text-primary"
        onClick={() => setIsTermsModalOpen(true)}
      >
        Terms & Conditions
      </span>
      <span> & </span>
      <span
        className="text-sm font-normal cursor-pointer font-lato text-primary"
        onClick={() => setIsTermsModalOpen(true)}
      >
        the Privacy Policy.
      </span>
    </div>
  );

  const inputClass = "border border-grey-450";

  const onSubmit = (data: any) => {
    saveUserData(data);
    Mixpanel.track("Vendorcode_entered", {
      vendorCode: userData.vendorCode,
    });
    sendOtp({
      body: {
        phoneNumber: countryCode + data.mobileNumber,
        otpType: "mobile",
        actionType: "SIGN_UP",
      },
      apiType: "send",
    })
      .then(() => setActiveStep(2))
      .catch((error) => {
        if (error?.response?.data?.error?.code === 2542) {
          setError("mobileNumber", {
            type: error?.response?.data?.error?.type,
          });
        } else {
          setSignUpError(error?.response?.data?.error?.type);
        }
      });
  };

  type FormInputs = {
    email: string;
    password: string;
    confirmPassword: string;
    mobileNumber: number;
    vendorCode: string;
  };

  const {
    formState: { errors, isValid, isDirty },
    getValues,
    handleSubmit,
    setError,
    control,
  } = useForm<FormInputs>({ mode: "onChange" });

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col sm:pt-[94px] w-screen sm:w-max pb-5 sm:pb-0">
          <div className="flex flex-col items-center sm:items-start sm:space-x-5 sm:flex-row pb-7">
            <div className="flex w-screen px-6 sm:w-max sm:justify-between pb-7 sm:pb-0 sm:px-0">
              <div className="mr-5 sm:mr-[10px] w-fit sm:w-[120px]">
                <Dropdown
                  dropdownClassname="w-[120px] h-[64px] border border-grey-450 flex justify-center px-[14px]"
                  showDropdown={showDropdown}
                  dropdownButtonOnClick={() => setShowDropdown((prev) => !prev)}
                  dropdownLabel={countryCodeDefaultValue}
                  countryList={coutryList}
                  dropdownValue={value}
                  listItemOnClick={(e) => {
                    e.stopPropagation();
                    saveCountryCode("+" + e.target.textContent.split("+").pop());
                    setValue(
                      e.target.textContent == "United States +1" ? (
                        <span className="flex items-center justify-start space-x-2 text-base font-medium text-black font-ssp">
                          <img src={`/images/png/USD.png`} alt="" width="35px" height="35px" />
                          <div>+1</div>
                        </span>
                      ) : e.target.textContent == "Canada +1" ? (
                        <span className="flex items-center justify-start space-x-2 text-base font-medium text-black font-ssp">
                          <img src={`/images/png/CAD.png`} alt="" width="35px" height="35px" />
                          <div>+1</div>
                        </span>
                      ) : e.target.textContent == "India +91" ? (
                        <span className="flex items-center justify-start space-x-2 text-base font-medium text-black font-ssp">
                          <img src={`/images/png/INR.png`} alt="" width="35px" height="35px" />
                          <div>+91</div>
                        </span>
                      ) : e.target.textContent == "United Kingdom +44" ? (
                        <span className="flex items-center justify-start space-x-2 text-base font-medium text-black font-ssp">
                          <img src={`/images/png/GBP.png`} alt="" width="35px" height="35px" />
                          <div>+44</div>
                        </span>
                      ) : (
                        <></>
                      ),
                    );
                    setShowDropdown(false);
                  }}
                  onBlur={() => {
                    setShowDropdown(false);
                  }}
                />
              </div>
              <div className="sm:w-[270px] w-full">
                <Controller
                  control={control}
                  name="mobileNumber"
                  rules={{ required: true, pattern: regexForMobileNumber }}
                  render={({ field: { name, value, onChange } }) => {
                    return (
                      <TextField
                        name={name}
                        type="number"
                        placeholder="Mobile No."
                        inputClasses={clsx(errors?.mobileNumber ? "border" : inputClass)}
                        placeholderStyle="text-black font-ssp font-medium text-base"
                        value={value}
                        // eslint-disable-next-line
                        errorMessage={getErrorMessage(
                          errors as Record<string, { type: any }>,
                          "mobileNumber",
                          "Mobile No.",
                        )}
                        error={errors.mobileNumber}
                        onChange={(v) => onChange(v)}
                        isValidate={
                          isDirty && !errors.mobileNumber && getValues("mobileNumber") !== undefined
                        }
                        required
                        fullWidth
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="w-screen sm:w-[400px] px-6 sm:px-0">
              <Controller
                control={control}
                name="email"
                rules={{ required: true, pattern: regexForEmailAddress }}
                render={({ field: { name, value, onChange } }) => {
                  return (
                    <TextField
                      name={name}
                      type="email"
                      placeholder="Email"
                      inputClasses={clsx(errors?.email ? "border" : inputClass)}
                      placeholderStyle="text-black font-ssp font-medium text-base"
                      value={value}
                      // eslint-disable-next-line
                      errorMessage={getErrorMessage(
                        errors as Record<string, { type: any }>,
                        "email",
                        "Email",
                      )}
                      error={errors.email}
                      onChange={(v) => onChange(v)}
                      isValidate={isDirty && !errors.email && getValues("email") !== undefined}
                      required
                      fullWidth
                    />
                  );
                }}
              />
            </div>
          </div>
          <div className="relative flex flex-col items-center sm:items-start sm:space-x-5 sm:flex-row pb-7">
            <div className="w-screen sm:w-[400px] pb-7 sm:pb-0 px-6 sm:px-0">
              <Controller
                control={control}
                name="password"
                rules={{ required: true, pattern: regexForPassword }}
                render={({ field: { name, value, onChange } }) => {
                  return (
                    <TextField
                      name={name}
                      type="password"
                      placeholder="Password"
                      inputClasses={clsx(errors?.password ? "border" : inputClass)}
                      placeholderStyle="text-black font-ssp font-medium text-base"
                      value={value}
                      error={errors.password ? true : false}
                      // eslint-disable-next-line
                      errorMessage={getErrorMessage(
                        errors as Record<string, { type: any }>,
                        "password",
                        "Password",
                      )}
                      onChange={(v) => onChange(v)}
                      isValidate={
                        isDirty && !errors.password && getValues("password") !== undefined
                      }
                      required
                      fullWidth
                    />
                  );
                }}
              />

              {errors.password && (
                <Tooltip
                  positionOfTip="right"
                  bgColor="bg-secondary-800"
                  tooltipStyles="!bottom-auto pb-4 md:pb-0"
                >
                  <div className="z-10 px-5 py-4 rounded-md sm:w-[372px] w-fit">
                    <div className="pb-[10px] text-black font-ssp font-bold text-sm">
                      Password criteria
                    </div>
                    <div className="flex items-center pb-2 text-sm font-normal font-ssp text-primary">
                      <span className="mr-1">
                        <DoubleVerifiedIcon />
                      </span>
                      Should be 8 words atleast
                    </div>
                    <div className="flex items-center pb-2 text-sm font-normal font-ssp text-error">
                      <span className="mr-1">
                        <DoubleVerifiedIcon fillColor="stroke-error" />
                      </span>
                      Should contain the special characters @$#+*
                    </div>
                    <div className="flex items-center pb-2 text-sm font-normal font-ssp text-grey-600">
                      <span className="mr-1">
                        <DoubleVerifiedIcon fillColor="stroke-grey-600" />
                      </span>
                      Should not be same as your email
                    </div>
                    <div className="flex items-center pb-2 text-sm font-normal font-ssp text-primary">
                      <span className="mr-1">
                        <DoubleVerifiedIcon />
                      </span>
                      Should contain atleast one uppercase letter
                    </div>
                    <div className="flex items-center pb-2 text-sm font-normal font-ssp text-error">
                      <span className="mr-1">
                        <DoubleVerifiedIcon fillColor="stroke-error" />
                      </span>
                      Should contain atleast one lowercase letter
                    </div>
                  </div>
                </Tooltip>
              )}
            </div>
            <div className="w-screen sm:w-[400px] px-6 sm:px-0">
              <Controller
                control={control}
                name="confirmPassword"
                rules={{
                  required: true,
                  validate: {
                    sameAs: () => {
                      return getValues("password") === getValues("confirmPassword");
                    },
                  },
                }}
                render={({ field: { name, value, onChange } }) => {
                  return (
                    <TextField
                      name={name}
                      type="password"
                      placeholder="Confirm Password"
                      inputClasses={clsx(errors?.confirmPassword ? "border" : inputClass)}
                      placeholderStyle="text-black font-ssp font-medium text-base"
                      value={value}
                      error={errors.confirmPassword}
                      // eslint-disable-next-line
                      errorMessage={getErrorMessage(
                        errors as Record<string, { type: any }>,
                        "confirmPassword",
                        "Confirm Password",
                      )}
                      onChange={(v) => onChange(v)}
                      isValidate={
                        isDirty &&
                        !errors.confirmPassword &&
                        getValues("confirmPassword") !== undefined
                      }
                      required
                      fullWidth
                    />
                  );
                }}
              />
            </div>
          </div>
          <div className="flex flex-col items-center sm:items-start sm:flex-row mb-[137px] sm:mb-48 space-y-5">
            <div className="w-screen sm:w-[400px] px-6 sm:px-0">
              <Controller
                control={control}
                name="vendorCode"
                rules={{ required: true, pattern: regexForSpecialChar }}
                render={({ field: { name, value, onChange } }) => {
                  return (
                    <TextField
                      name={name}
                      type="text"
                      required
                      placeholder="Vendor Code"
                      inputClasses={clsx(errors?.vendorCode ? "border" : inputClass)}
                      placeholderStyle="text-grey font-ssp font-medium text-base"
                      value={value ?? ""}
                      error={errors.vendorCode}
                      // eslint-disable-next-line
                      errorMessage={getErrorMessage(
                        errors as Record<string, { type: any }>,
                        "vendorCode",
                        "Vendor",
                      )}
                      onChange={(v) => onChange(v)}
                      fullWidth
                    />
                  );
                }}
              />
            </div>
            <div className="w-screen sm:w-[400px] pl-10">
              <Checkbox
                label={RadioLabel}
                value={isAgree ? "true" : "false"}
                name="isAgreeTermsAndConditions"
                rootclassName="rounded-full !w-6 !h-6 !border-secondary-600"
                checkboxClassname="rounded-full !w-4 !h-4 checked:!bg-primary-100"
                labelClassName="w-2/3 ml-7 cursor-pointer"
                handleChange={(e) => {
                  setIsAgree(e.target.checked);
                }}
              />
            </div>
          </div>
          <div className="flex justify-center mb-[15px]">
            <Button
              bgColor={`${isValid && isAgree ? "bg-primary-1050" : "bg-grey-500"}`}
              fontStyle={{
                fontFamily: "font-ssp",
                fontSize: "text-base",
                fontWeight: "font-medium",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderWidth: "border",
                borderRadius: "rounded",
              }}
              className="w-[220px] h-[54px] z-10"
              disabled={!isValid || !isAgree}
            >
              Verify
            </Button>
          </div>
          {signUpError && <ErrorField errorMessage={signUpError} errorClassname="self-center" />}
        </div>
      </form>
    </>
  );
};

export default StepOne;
